












































import {Component, Prop, Vue} from "vue-property-decorator";
import {PropType} from "vue";
import moment from "moment";
import {IPraxisRoute} from "@/interfaces/Student/IKiPilotPraxis";

@Component
export default class KiPilotPraxisRouteList extends Vue {
  @Prop({type: Array as PropType<Array<IPraxisRoute>>, default: () => []})
  public routes!: Array<IPraxisRoute>;

  @Prop({type: Number, default: null})
  public selectedRouteId!: number | null;

  public get sortedRoutes(): Array<IPraxisRoute> {
    return [...this.routes].sort((a, b) => {
      const dateTimeA = `${a.date || ""}T${a.time || "00:00"}`;
      const dateTimeB = `${b.date || ""}T${b.time || "00:00"}`;
      return dateTimeB.localeCompare(dateTimeA);
    });
  }

  public formatDate(date?: string): string {
    return date ? moment(date).format("DD.MM.YYYY") : "-";
  }

  // Uses the route's actual tracked start/end (not the scheduled lesson/exam time), since that's
  // when the drive really happened; endedAt is missing while the route is still being recorded.
  public formatSubtitle(route: IPraxisRoute): string {
    if (!route.startedAt) return `${this.formatDistance(route)} km`;

    const start = moment(route.startedAt).format("HH:mm");
    if (!route.endedAt) {
      return `${start} Uhr · ${this.$t("students.ki_pilot_praxis_ongoing_drive")}`;
    }
    return `${start} - ${moment(route.endedAt).format("HH:mm")} Uhr · ${this.formatDistance(route)} km`;
  }

  public formatDistance(route: IPraxisRoute): string {
    const meters = route.distanceInMeters;
    return meters ? (meters / 1000).toFixed(1).replace(".", ",") : "0,0";
  }
}
